import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import ViewList from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { isValid } from '@totalsoft/pure-validations-react';
import PropertyGeneralDataComponent from './PropertyGeneralDataComponent';
import { ADMIN_PROPERTIES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

export const PropertyGeneralDataCard = ({
  property,
  propertyTypes,
  propertyCategories,
  contexts,
  applications,
  onChange,
  onSave,
  onLookupPropertyChanged,
  onApplicationsChanged,
  validation
}) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_PROPERTIES_WRITE);

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('Property.GeneralData')}
      actions={
        <IconButton
          type='save'
          fontSize='medium'
          color='transparent'
          tooltip={t('SaveChanges')}
          onClick={onSave}
          disabled={!canWrite || !property.changed || property.saving || !(validation |> isValid)}
        />
      }
    >
      <Prompt when={property.changed && property.id && !property.saving} message={t('Property.LeavingWithoutSavingProperty')} />
      <PropertyGeneralDataComponent
        property={property}
        propertyTypes={propertyTypes}
        propertyCategories={propertyCategories}
        contexts={contexts}
        onChange={onChange}
        onLookupPropertyChanged={onLookupPropertyChanged}
        onApplicationsChanged={onApplicationsChanged}
        validation={validation}
        applications={applications}
      />
    </Card>
  );
};

PropertyGeneralDataCard.propTypes = {
  property: PropTypes.object.isRequired,
  propertyTypes: PropTypes.array.isRequired,
  propertyCategories: PropTypes.array.isRequired,
  contexts: PropTypes.array.isRequired,
  applications: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired,
  onApplicationsChanged: PropTypes.func,
  validation: PropTypes.object.isRequired
};

export default PropertyGeneralDataCard;
